import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const CreateErrorMessage = styled('p')`
  color: ${theme.colors.supportError};
  font-size: ${theme.font.sizes.p3};
  margin-top: ${theme.spacings.xxxlarge};
  text-align: center;

  &:not(.visible) {
    display: none;
  }
`;

export const ProfileSelector = styled('div')`
  border-bottom: 1px solid ${theme.colors.gray3};
  margin-top: ${theme.spacings.medium};
  padding-bottom: ${theme.spacings.large};

  span {
    display: block;
    font-size: ${theme.font.sizes.p2};
    color: ${theme.colors.gray4};
  }

  div {
    align-items: center;
    display: flex;
    margin-top: ${theme.spacings.xsmall};

    label + label {
      margin-left: ${theme.spacings.medium};
    }
  }
`;

export const TextArea = styled('textarea')`
  min-width: 350px;
  max-width: 350px;
  max-height: 50px;
  min-height: 50px;
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;

`;

export const TelegramWrapper = styled('div')`
  display: flex; 
  flex-direction: column; 
  gap: 20px; 
  justify-content: start; 
  align-items: start; 
  margin: 32px 0;
`;

export const ClickableColumn = styled('div')`
  display: flex; 
  flex-direction: column;
  cursor: pointer;
`;
export const Row = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Container = styled('div')`
  display: flex; 
  flex-direction: row; 
  align-content: center;
`;
export const TextAlignedLeft = styled('p')`
  text-align: left;
`;

export const TextRegistered = styled('p')`
  color: ${theme.colors.gray6};
  font-size: ${theme.font.sizes.p1};
  line-height: ${theme.font.lineHeights.p1};
  margin-top: ${theme.spacings.xxlarge};
  text-align: center;

  a {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-weight: ${theme.font.bold};
    justify-content: center;

    svg {
      margin-right: ${theme.spacings.xsmall};
    }
  }
`;

export const WrapperButton = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacings.xxxlarge};
`;

export const WrapperInput = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.xxxlarge};
  margin-top: ${theme.spacings.xxxlarge};

  .checkbox-no-label {
    align-items: center;
    display: flex;

    span {
      color: ${theme.colors.gray5};
      font-size: ${theme.font.sizes.p2};
      line-height: ${theme.font.lineHeights.p2};

      a {
        color: ${theme.colors.primary};
        text-decoration: underline;
      }
    }
  }

  .validation-error {
    color: ${theme.colors.supportError};
    font-size: ${theme.font.sizes.p3};
    margin-top: 5px;
    text-align: right;
  }
`;

export const WrapperMain = styled('main')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 30px 0;

  .link {
    align-items: center;
    display: flex;
    font-size: ${theme.font.sizes.p1};
    font-weight: ${theme.font.bold};
    justify-content: center;
    line-height: ${theme.font.lineHeights.p1};
    margin-top: ${theme.spacings.xxlarge};
    transition: color .25s;
  }

  .whatsapp-link {
    color: #578C19;

    svg {
      margin-right: ${theme.spacings.small};
    }

    &:hover {
      color: #2E8019;
    }
  }

  .disabled {
    pointer-events: none;
    cursor: default;
  }
   
  .login-link {
    color: ${theme.colors.primary};

    &:hover {
      color: ${theme.colors.primaryDark};
    }
  }
`;
